app.controller('BrowseEditSolutionGeneralOptionsController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {


    const siteHelper = $rootScope.site_helper;

    let unaffectedCart = [];
    const affectedCart = [];
    let matchedUnaffectedCart = [];
    let unrelatedCart = [];

    $scope.affected_cart_tally = 0;
    $scope.visible_cart_type_amt = 0;


    let defaultEditCartID = null;
    $scope.view_model = {
        edit_cart_id: null,
        edit_available_in: "all",
    }
    $scope.is_editing = false;
    $scope.editing_model_id = null;

    $scope.cart_models = {
        cabinet_only: null,
        solution_cart: null,
        full_cart: null
    }

    let categoryCartID = null;
    let navigationRequestRangeID = null;
    let navigationSiteRangeID = null;

    const propertyConfigs = {
        site_range: {name: "Range", state_ids: ["request_range_id", "site_range_id"]},
        colour_route: {name: "Colour", state_ids: "colour_id", available_non_cabinet: true},
        style_route: {name: "Style", state_ids: "style_id", available_non_cabinet: true},
        edge_option: {name: "Edge Option", state_ids: "edge_option_id"},
        handle_colour: {name: "Handle Colour", state_ids: "handle_colour_id"},
        assembly: {name: "Assembly", state_ids: "assembly_id"}
    }

    const prePropertyRouteIDs = {};

    const EditCartModel = function () {
        this.name = "";
        this.disabled = false;
        this.cart_lines = [];
        this.no_edit_required_lines = [];
        this.can_not_edit_lines = [];
        this.editable_lines = [];
        this.editable_cabinet_lines = [];
        this.editable_non_cabinet_lines = [];
        this.unrelated_cart_lines = [];
        this.no_edit_required_quantity = 0;
        this.can_not_edit_quantity = 0;
        this.editable_quantity = 0;
        this.disable_all = false;
        this.disable_any = false;
        this.property_models = {};
        this.navigation_property_model_list = [];
        this.current_property_model_list = [];
        this.all_product_choice = null;
        this.any_product_choice = null;
        this.default_edit_available_in = "all";
    }

    const EditSolutionGeneralOptionsPropertyModel = function () {
        this.model_id = null;
        this.config = null;
        this.navigation_state = null;
        this.navigation_choice_ids = [];
        this.navigation_available_all_choice_ids = [];
        this.navigation_available_any_choice_ids = [];
        this.edit_navigation_ids = {};
        this.edit_navigation_values = {};
        this.edit_choice_ids = [];
        this.current_model = null;
        this.current_choice = null;
        this.current_choice_id = null
    }


    function prepareEditGeneralOptions() {

        determineSolutionCarts();

        for (let cartModelID in $scope.cart_models) {
            determineAvailableProperties($scope.cart_models[cartModelID]);
        }

        $scope.resetEdit();

        setTimeout(() => {
            $scope.$apply();
        }, 1)
    }

    function determineSolutionCarts() {

        const cabinetOnlyModel = new EditCartModel();
        const solutionCartModel = new EditCartModel();
        const fullCartModel = new EditCartModel();

        cabinetOnlyModel.name = "Solution Cabinets";
        solutionCartModel.name = "Solution Cart";
        fullCartModel.name = "Full Cart";

        $scope.cart_models.cabinet_only = cabinetOnlyModel;
        $scope.cart_models.solution_cart = solutionCartModel;
        $scope.cart_models.full_cart = fullCartModel;


        let orderLines = $rootScope.model.order.current_order ? $rootScope.model.order.current_order.lines : null;

        orderLines = orderLines ? orderLines : [];

        categoryCartID = $scope.category_cart_id;
        navigationRequestRangeID = $scope.navigation_ids.request_range_id;
        navigationSiteRangeID = navigationRequestRangeID ? $scope.navigation_ids.site_range_id : null;
        if (!categoryCartID) {
            cabinetOnlyModel.disabled = true;
            solutionCartModel.disabled = true;
        }

        for (let i = 0; i < orderLines.length; i++) {
            const orderLine = orderLines[i];
            const isCurrentSolutionLine = categoryCartID && orderLine.category_cart_id === categoryCartID;
            let isCabinetLine = false;
            let editRequired = false;
            let canNotEdit = false;
            orderLine.state_ids = orderLine.state_ids ? orderLine.state_ids : {}
            const stateIDs = orderLine.state_ids;
            const baseComponentID = stateIDs.base_component_id;
            isCabinetLine = baseComponentID === "solution";
            const cacheObject = $rootScope.service.cache_local_server.getComponentObject(baseComponentID, stateIDs.parent_category_group_id, stateIDs.parent_category_id, stateIDs.alpha_category_id, true);
            editRequired = cacheObject && (cacheObject.requires_colour || cacheObject.requires_style || isCabinetLine);

            if (editRequired && (!navigationSiteRangeID || (isCabinetLine && !orderLine.unit) || (!isCabinetLine && navigationRequestRangeID === 'pronto'))) {
                editRequired = false;
                canNotEdit = true;
            }

            if (isCabinetLine && isCurrentSolutionLine) {
                cabinetOnlyModel.cart_lines.push(orderLine);
                if (editRequired) {
                    cabinetOnlyModel.editable_lines.push(orderLine);
                    cabinetOnlyModel.editable_cabinet_lines.push(orderLine)
                } else if (canNotEdit) {
                    cabinetOnlyModel.can_not_edit_lines.push(orderLine);
                } else {
                    cabinetOnlyModel.no_edit_required_lines.push(orderLine);
                }
            } else {
                cabinetOnlyModel.unrelated_cart_lines.push(orderLine);
            }

            if (isCurrentSolutionLine) {
                solutionCartModel.cart_lines.push(orderLine);
                if (editRequired) {
                    solutionCartModel.editable_lines.push(orderLine);
                    if (isCabinetLine) {
                        solutionCartModel.editable_cabinet_lines.push(orderLine)
                    } else {
                        solutionCartModel.editable_non_cabinet_lines.push(orderLine)
                    }
                } else if (canNotEdit) {
                    solutionCartModel.can_not_edit_lines.push(orderLine);
                } else {
                    solutionCartModel.no_edit_required_lines.push(orderLine);
                }
            } else {
                solutionCartModel.unrelated_cart_lines.push(orderLine);
            }

            fullCartModel.cart_lines.push(orderLine);
            if (editRequired) {
                fullCartModel.editable_lines.push(orderLine);
                if (isCabinetLine) {
                    fullCartModel.editable_cabinet_lines.push(orderLine)
                } else {
                    fullCartModel.editable_non_cabinet_lines.push(orderLine)
                }
            } else if (canNotEdit) {
                fullCartModel.can_not_edit_lines.push(orderLine);
            } else {
                fullCartModel.no_edit_required_lines.push(orderLine);
            }
        }


        let preferFullCart = false;

        if (!solutionCartModel.disabled && solutionCartModel.cart_lines.length === cabinetOnlyModel.cart_lines.length) {
            cabinetOnlyModel.disabled = true;
        }

        if (!fullCartModel.disabled && fullCartModel.cart_lines.length === solutionCartModel.cart_lines.length) {
            solutionCartModel.disabled = true;
            if (solutionCartModel.cart_lines.length) {
                preferFullCart = true
            }
        }

        for (let cartModelID in $scope.cart_models) {
            const cartModel = $scope.cart_models[cartModelID];
            let noEditRequiredQuantity = 0;
            let canNotEditQuantity = 0;
            let editableQuantity = 0;
            for (let i = 0; i < cartModel.no_edit_required_lines.length; i++) {
                noEditRequiredQuantity += cartModel.no_edit_required_lines[i].quantity;
            }
            for (let i = 0; i < cartModel.can_not_edit_lines.length; i++) {
                canNotEditQuantity += cartModel.can_not_edit_lines[i].quantity;
            }
            for (let i = 0; i < cartModel.editable_lines.length; i++) {
                editableQuantity += cartModel.editable_lines[i].quantity;
            }
            cartModel.no_edit_required_quantity = noEditRequiredQuantity;
            cartModel.can_not_edit_quantity = canNotEditQuantity;
            cartModel.editable_quantity = editableQuantity;
        }
        defaultEditCartID = null;
        $scope.visible_cart_type_amt = 0;
        if (!fullCartModel.disabled) {
            $scope.visible_cart_type_amt++;
        }
        if (!solutionCartModel.disabled) {
            $scope.visible_cart_type_amt++;
        }
        if (!cabinetOnlyModel.disabled) {
            $scope.visible_cart_type_amt++;
        }
        if (!solutionCartModel.disabled && solutionCartModel.editable_quantity) {
            defaultEditCartID = "solution_cart";
        } else if (preferFullCart && (!fullCartModel.disabled && fullCartModel.editable_quantity)) {
            defaultEditCartID = "full_cart";
        } else if (!cabinetOnlyModel.disabled && cabinetOnlyModel.editable_quantity) {
            defaultEditCartID = "cabinet_only";
        } else {
            defaultEditCartID = "full_cart";
        }
    }

    function determineAvailableProperties(cartModel) {
        if (cartModel.disabled) {
            return;
        }

        let cabinetCache = $rootScope.model.cache_local_server.component.solution.products;
        cabinetCache = cabinetCache ? cabinetCache : {}

        const cabinetProductIDs = [];
        let nonCabinetAllSiteRangeIDs = null;
        let nonCabinetAnySiteRangeIDs = null;
        for (let i = 0; i < cartModel.editable_lines.length; i++) {
            const cartLine = cartModel.editable_lines[i];
            const isCabinetLine = cartLine.state_ids.base_component_id === "solution";
            if (isCabinetLine) {
                if (!cabinetProductIDs.includes(cartLine.unit)) {
                    cabinetProductIDs.push(cartLine.unit);
                }
            } else {
                const siteRangeID = cartLine.state_ids.site_range_id;
                if (nonCabinetAllSiteRangeIDs === null) {
                    nonCabinetAllSiteRangeIDs = [siteRangeID];
                } else if (nonCabinetAllSiteRangeIDs[0] !== siteRangeID) {
                    nonCabinetAllSiteRangeIDs.length = 0;
                }
                if (!nonCabinetAnySiteRangeIDs) {
                    nonCabinetAnySiteRangeIDs = [];
                }
                if (!nonCabinetAnySiteRangeIDs.includes(siteRangeID)) {
                    nonCabinetAnySiteRangeIDs.push(siteRangeID)
                }

            }
        }

        cartModel.property_models = {}
        for (let modelID in propertyConfigs) {
            const config = propertyConfigs[modelID]
            const propertyModel = new EditSolutionGeneralOptionsPropertyModel();
            propertyModel.model_id = modelID;
            propertyModel.config = config;
            cartModel.property_models[modelID] = propertyModel;
        }

        cartModel.navigation_property_model_list = [];

        const navigationStateList = $rootScope.navigation_model.state_list;

        const stateIndex = $scope.context_state_index ? $scope.context_state_index : navigationStateList.length - 1;

        let haveAnyPropertyModel = false;
        for (let i = 0; i < stateIndex; i++) {
            const navigationState = navigationStateList[i];
            const propertyModel = cartModel.property_models[navigationState.model_id];
            if (!propertyModel) {
                if (haveAnyPropertyModel) {
                    break;
                }
                prePropertyRouteIDs[navigationState.navigation_pointer] = navigationState.choice_id;
                continue;
            }
            haveAnyPropertyModel = true;
            propertyModel.navigation_state = navigationState;
            propertyModel.navigation_choice_ids = navigationState.model.choice_order.slice();
            cartModel.navigation_property_model_list.push(propertyModel);
        }

        cartModel.all_product_choice = createAllProductChoice(cabinetProductIDs, nonCabinetAllSiteRangeIDs, cabinetCache);
        cartModel.any_product_choice = createAnyProductChoice(cabinetProductIDs, nonCabinetAnySiteRangeIDs, cabinetCache);

        let disableAll = false;
        let disableAny = false;
        for (let modelID in cartModel.property_models) {
            const propertyModel = cartModel.property_models[modelID];
            propertyModel.navigation_available_all_choice_ids = filterPropertyChoiceIDs(modelID, propertyModel.navigation_choice_ids, cartModel.all_product_choice, navigationSiteRangeID);
            propertyModel.navigation_available_any_choice_ids = filterPropertyChoiceIDs(modelID, propertyModel.navigation_choice_ids, cartModel.any_product_choice, navigationSiteRangeID);

        }

        const haveNonCabinets = !!cartModel.editable_non_cabinet_lines.length;
        for (let i = 0; i < cartModel.navigation_property_model_list.length; i++) {
            const propertyModel = cartModel.navigation_property_model_list[i];
            const availableNonCabinet = propertyModel.config.available_non_cabinet;
            if (!propertyModel.navigation_available_all_choice_ids.length) {
                if (availableNonCabinet || !haveNonCabinets) {
                    disableAll = true;
                }
            }
            if (!propertyModel.navigation_available_any_choice_ids.length) {
                if (availableNonCabinet || !haveNonCabinets) {
                    disableAny = true;
                }
            }
        }
        if (!cartModel.editable_quantity) {
            disableAll = true;
            disableAny = true;
        }
        cartModel.disable_all = disableAll;
        cartModel.disable_any = disableAny;
        cartModel.default_edit_available_in = (!disableAll || disableAny) ? 'all' : 'any';
    }


    function createAllProductChoice(cabinetProductIDs, nonCabinetAllSiteRangeIDs, cabinetCache) {
        let mergedChoice = null

        if (cabinetProductIDs.length) {

            for (let i = 0; i < cabinetProductIDs.length; i++) {
                const productID = cabinetProductIDs[i];
                const product = cabinetCache[productID];

                if (!product || !product.site_range || !product.assembly_ids) {
                    mergedChoice = null;
                    break
                }
                const productSiteRange = validCabinetSiteRange(product, navigationSiteRangeID);
                if (!mergedChoice) {
                    mergedChoice = {
                        site_range: {},
                        assembly_ids: product.assembly_ids.slice(),
                        valid: true
                    };
                    for (let siteRangeID in productSiteRange) {
                        if (!nonCabinetAllSiteRangeIDs || nonCabinetAllSiteRangeIDs.includes(siteRangeID)) {
                            mergedChoice.site_range[siteRangeID] = {
                                colour_exceptions: [],
                                style_exceptions: []
                            }
                        }
                    }
                }

                for (let siteRangeID in mergedChoice.site_range) {
                    if (!productSiteRange[siteRangeID]) {
                        delete mergedChoice.site_range[siteRangeID];
                    }
                }
                if (!siteHelper.keyCount(mergedChoice.site_range)) {
                    mergedChoice = null;
                    break
                }

                for (let siteRangeID in productSiteRange) {
                    if (mergedChoice.site_range[siteRangeID]) {
                        const colourExceptions = productSiteRange[siteRangeID].colour_exceptions;
                        const styleExceptions = productSiteRange[siteRangeID].style_exceptions;
                        if (colourExceptions) {
                            for (let j = 0; j < colourExceptions.length; j++) {
                                const colourID = colourExceptions[j];
                                if (!mergedChoice.site_range[siteRangeID].colour_exceptions.includes(colourID)) {
                                    mergedChoice.site_range[siteRangeID].colour_exceptions.push(colourID);
                                }
                            }
                        }
                        if (styleExceptions) {
                            for (let j = 0; j < styleExceptions.length; j++) {
                                const styleID = styleExceptions[j];
                                if (!mergedChoice.site_range[siteRangeID].style_exceptions.includes(styleID)) {
                                    mergedChoice.site_range[siteRangeID].style_exceptions.push(styleID);
                                }
                            }
                        }
                    }
                }

                for (let j = 0; j < mergedChoice.assembly_ids.length; j++) {
                    const assemblyID = mergedChoice.assembly_ids[j]
                    if (!product.assembly_ids.includes(assemblyID)) {
                        mergedChoice.assembly_ids.splice(j, 1);
                        j--;
                    }
                }
            }
        } else if (nonCabinetAllSiteRangeIDs && nonCabinetAllSiteRangeIDs.length) {
            mergedChoice = {
                site_range: {},
                assembly_ids: [],
                valid: true
            };
            mergedChoice.site_range[nonCabinetAllSiteRangeIDs[0]] = {
                colour_exceptions: [],
                style_exceptions: []
            }
        }

        mergedChoice = mergedChoice ? mergedChoice : {
            site_range: {},
            assembly_ids: [],
            valid: false
        }
        return mergedChoice;
    }


    function createAnyProductChoice(cabinetProductIDs, nonCabinetAnySiteRangeIDs, cabinetCache) {
        const mergedChoice = {
            site_range: {},
            assembly_ids: [],
            valid: true
        };
        if (cabinetProductIDs.length) {

            for (let i = 0; i < cabinetProductIDs.length; i++) {
                const productID = cabinetProductIDs[i];
                const product = cabinetCache[productID];
                if (!product || !product.site_range || !product.assembly_ids) {
                    continue;
                }
                const productSiteRange = validCabinetSiteRange(product, navigationSiteRangeID);
                for (let siteRangeID in productSiteRange) {
                    let colourExceptions = productSiteRange[siteRangeID].colour_exceptions;
                    let styleExceptions = productSiteRange[siteRangeID].style_exceptions;
                    colourExceptions = colourExceptions ? colourExceptions : [];
                    styleExceptions = styleExceptions ? styleExceptions : [];
                    if (!mergedChoice.site_range[siteRangeID]) {
                        mergedChoice.site_range[siteRangeID] = {
                            colour_exceptions: colourExceptions.slice(),
                            style_exceptions: styleExceptions.slice()
                        }
                    } else {
                        for (let j = 0; j < mergedChoice.site_range[siteRangeID].colour_exceptions.length; j++) {
                            const colourID = mergedChoice.site_range[siteRangeID].colour_exceptions[j];
                            if (!colourExceptions.includes(colourID)) {
                                mergedChoice.site_range[siteRangeID].colour_exceptions.splice(j, 1);
                                j--;
                            }
                        }
                        for (let j = 0; j < mergedChoice.site_range[siteRangeID].style_exceptions.length; j++) {
                            const styleID = mergedChoice.site_range[siteRangeID].style_exceptions[j];
                            if (!styleExceptions.includes(styleID)) {
                                mergedChoice.site_range[siteRangeID].style_exceptions.splice(j, 1);
                                j--;
                            }
                        }
                    }
                }

                for (let j = 0; j < product.assembly_ids.length; j++) {
                    const assemblyID = product.assembly_ids[j]
                    if (!mergedChoice.assembly_ids.includes(assemblyID)) {
                        mergedChoice.assembly_ids.push(assemblyID);
                    }
                }
            }

        } else if (nonCabinetAnySiteRangeIDs) {
            for (let i = 0; i < nonCabinetAnySiteRangeIDs.length; i++) {
                const siteRangeID = nonCabinetAnySiteRangeIDs[i];
                mergedChoice.site_range[siteRangeID] = {
                    colour_exceptions: [],
                    style_exceptions: []
                }
            }
        }
        return mergedChoice;
    }

    function validCabinetSiteRange(cachedCabinet, currentSiteRangeID) {
        const isTallstor = cachedCabinet.alpha_category_ids.includes("tallstor");
        if (!isTallstor) {
            return cachedCabinet.site_range
        }
        const siteRange = {};
        if (cachedCabinet.site_range[currentSiteRangeID]) {
            siteRange[currentSiteRangeID] = cachedCabinet.site_range[currentSiteRangeID];
        }
        return siteRange;
    }

    function filterPropertyChoiceIDs(modelID, choiceIDs, productChoice, forSiteRangeID) {

        if (!productChoice.valid) {
            return [];
        }
        const siteRange = productChoice.site_range;
        let exceptions = null;
        if (modelID === "colour_route" || modelID === "style_route") {
            const fromSiteRange = forSiteRangeID ? siteRange[forSiteRangeID] : null;
            if (fromSiteRange) {
                if (modelID === "colour_route") {
                    exceptions = fromSiteRange.colour_exceptions;
                } else {
                    exceptions = fromSiteRange.style_exceptions;
                }
            }

        }
        const validIDs = [];
        for (let i = 0; i < choiceIDs.length; i++) {
            const choiceID = choiceIDs[i]
            if (modelID === "site_range") {
                if (!siteRange[choiceID]) {
                    continue;
                }
            } else if (modelID === "colour_route" || modelID === "style_route") {
                if (!exceptions || exceptions.includes(choiceID)) {
                    continue;
                }
            } else if (modelID === "assembly") {
                if (!productChoice.assembly_ids.includes(choiceID)) {
                    continue;
                }

            }
            validIDs.push(choiceID);
        }
        return validIDs
    }

    function getCurrentNavigationModel(previous) {
        const cartModel = $scope.currentCartModel();
        const routeIDs = siteHelper.simpleCloneObject(prePropertyRouteIDs);

        let length = cartModel.current_property_model_list.length
        if (previous) {
            length--;
        }
        for (let i = 0; i < length; i++) {
            const propertyModel = cartModel.current_property_model_list[i];
            const choiceID = propertyModel.current_choice_id;
            if (!choiceID) {
                break;
            }
            routeIDs[propertyModel.current_model.navigation_pointer] = choiceID;
        }

        return $rootScope.navigation_manager.createNavigationModel(null, routeIDs);
    }

    function handleEditProperty(modelID) {
        selectModelID(modelID);
        if (!$scope.editing_model_id) {
            return false;
        }
        const cartModel = $scope.currentCartModel();
        const navigationModel = getCurrentNavigationModel(true);
        const navigationState = navigationModel.state_list.length ? navigationModel.state_list[navigationModel.state_list.length - 1] : null;
        if (!navigationState) {
            return false;
        }
        const editedModel = navigationState.model;
        if (!editedModel || editedModel.id !== modelID || !editedModel.choice_order.length) {
            return false;
        }
        $scope.is_editing = true;
        const currentSiteRangeID = navigationModel.state_ids.site_range_id;
        const productChoice = $scope.view_model.edit_available_in === "all" ? cartModel.all_product_choice : cartModel.any_product_choice;
        const validChoiceIDs = filterPropertyChoiceIDs(modelID, editedModel.choice_order, productChoice, currentSiteRangeID);
        const propertyModel = cartModel.current_property_model_list[cartModel.current_property_model_list.length - 1];
        propertyModel.edit_navigation_ids = navigationModel.state_ids;
        propertyModel.edit_navigation_values = navigationModel.state_values;
        propertyModel.edit_choice_ids = validChoiceIDs;
        return true;
    }


    $scope.editProperty = function (modelID) {
        const cartModel = $scope.currentCartModel();
        let currentSiteRangeID = null;
        const productChoice = $scope.view_model.edit_available_in === "all" ? cartModel.all_product_choice : cartModel.any_product_choice;
        for (let i = 0; i < cartModel.current_property_model_list.length - 1; i++) {
            const propertyModel = cartModel.current_property_model_list[i];
            if (propertyModel.model_id === modelID) {
                break;
            }
            propertyModel.edit_choice_ids = filterPropertyChoiceIDs(propertyModel.model_id, propertyModel.current_model.choice_order, productChoice, currentSiteRangeID);
            if (propertyModel.current_model.navigation_pointer === "site_range_id") {
                currentSiteRangeID = propertyModel.current_choice_id;
            }
        }
        handleEditProperty(modelID);
    }

    function selectModelID(modelID) {
        const cartModel = $scope.currentCartModel();
        let found = false;
        if (modelID) {
            for (let i = 0; i < cartModel.current_property_model_list.length; i++) {
                const propertyModel = cartModel.current_property_model_list[i];
                if (propertyModel.model_id === modelID) {
                    found = true;
                    cartModel.current_property_model_list.length = i + 1;
                    break;
                }
            }
        }
        if (found) {
            $scope.editing_model_id = modelID;
        } else {
            $scope.resetEdit();
        }
    }

    function handlePropertySelected(choiceID) {
        selectModelID($scope.editing_model_id);
        if (!$scope.editing_model_id) {
            return false;
        }

        const cartModel = $scope.currentCartModel();

        let currentSiteRangeID = null;
        for (let i = 0; i < cartModel.current_property_model_list.length; i++) {
            const propertyModel = cartModel.current_property_model_list[i];
            if (propertyModel.current_model.navigation_pointer === "site_range_id") {
                currentSiteRangeID = i === cartModel.current_property_model_list.length - 1 ? choiceID : propertyModel.current_choice_id;
            }
        }

        const lastPropertyModel = cartModel.current_property_model_list[cartModel.current_property_model_list.length - 1];
        const productChoice = $scope.view_model.edit_available_in === "all" ? cartModel.all_product_choice : cartModel.any_product_choice;
        const lastModelValidChoiceIDs = filterPropertyChoiceIDs(lastPropertyModel.model_id, lastPropertyModel.current_model.choice_order, productChoice, currentSiteRangeID);
        if (!lastModelValidChoiceIDs.includes(choiceID)) {
            return false;
        }
        lastPropertyModel.current_choice = lastPropertyModel.current_model.choices[choiceID];
        lastPropertyModel.current_choice_id = choiceID;

        const routeIDs = siteHelper.simpleCloneObject(prePropertyRouteIDs);
        for (let i = 0; i < cartModel.current_property_model_list.length; i++) {
            const propertyModel = cartModel.current_property_model_list[i];
            routeIDs[propertyModel.current_model.navigation_pointer] = propertyModel.current_choice_id;
        }

        const navigationModel = $rootScope.navigation_manager.createNavigationModel(null, routeIDs);
        const navigationState = navigationModel.state_list.length ? navigationModel.state_list[navigationModel.state_list.length - 1] : null;
        if (!navigationState) {
            return false;
        }

        const nextModelID = navigationState.model_id !== $scope.editing_model_id ? navigationState.model_id : null;
        const propertyModel = nextModelID ? cartModel.property_models[nextModelID] : null;
        if (!propertyModel) {
            return false;
        }

        const editedModel = navigationState.model;
        if (!editedModel.choice_order.length) {
            return false;
        }
        propertyModel.current_model = editedModel;

        cartModel.current_property_model_list.push(propertyModel);

        const validChoiceIDs = filterPropertyChoiceIDs(nextModelID, editedModel.choice_order, productChoice, currentSiteRangeID);

        if (propertyModel.current_choice_id && !validChoiceIDs.includes(propertyModel.current_choice_id)) {
            propertyModel.current_choice_id = null;
            propertyModel.current_choice = null;
        }
        if (!validChoiceIDs.length) {
            return false;
        }
        if (validChoiceIDs.length === 1) {
            propertyModel.edit_choice_ids = validChoiceIDs;
            $scope.editing_model_id = nextModelID;
            return handlePropertySelected(validChoiceIDs[0]);
        }

        return handleEditProperty(nextModelID);
    }

    $scope.onPropertySelected = function (choiceID) {
        const willShowProperty = handlePropertySelected(choiceID);
        if (!willShowProperty) {
            $scope.is_editing = false;
            $scope.show_edit_response = true;

            resetEditResponse();

            updateAffectedSolutionCart();
            applyToCart();

        }
        if ($scope.validatePagePosition) {
            $scope.validatePagePosition();
        }
    }

    function getSubmitStateIDs(ignoreLegacy) {

        const navigationModel = getCurrentNavigationModel();
        const stateIDs = {};
        for (let modelID in propertyConfigs) {
            const config = propertyConfigs[modelID];
            const fromStateIDs = Array.isArray(config.state_ids) ? config.state_ids : [config.state_ids];
            for (let i = 0; i < fromStateIDs.length; i++) {
                const stateID = fromStateIDs[i];
                stateIDs[stateID] = navigationModel.state_ids[stateID] ? navigationModel.state_ids[stateID] : null
            }
        }
        return stateIDs;
    }

    function updateAffectedSolutionCart() {
        const cartModel = $scope.currentCartModel();
        affectedCart.length = 0;
        unaffectedCart = cartModel.no_edit_required_lines.concat(cartModel.can_not_edit_lines);
        matchedUnaffectedCart = cartModel.no_edit_required_lines.slice();
        unrelatedCart = cartModel.unrelated_cart_lines;
        $scope.edit_cart_response.can_not_replace_tally = cartModel.can_not_edit_quantity;

        if (!cartModel.current_property_model_list.length) {
            return;
        }

        for (let i = 0; i < cartModel.can_not_edit_lines.length; i++) {
            const cartLine = cartModel.can_not_edit_lines[i];
            $scope.edit_cart_response.apply_cart_line_errors.push({
                name: cartLine.description,
                quantity: cartLine.quantity,
                error: "Cannot be edited"
            })
        }

        const stateIDs = getSubmitStateIDs();
        const nonCabinetStateIDs = getSubmitStateIDs(true);

        const cabinetCache = $rootScope.model.cache_local_server.component.solution.products;

        for (let i = 0; i < cartModel.editable_lines.length; i++) {
            const cartLine = cartModel.editable_lines[i];

            let canNotEdit = false;
            let affected = false;
            const isCabinetLine = cartLine.state_ids.base_component_id === "solution";
            if (isCabinetLine) {
                const cachedCabinet = cabinetCache[cartLine.unit];
                if (!cachedCabinet) {
                    canNotEdit = true;
                } else {
                    const productSiteRange = validCabinetSiteRange(cachedCabinet, cartLine.site_range);
                    const siteRange = stateIDs.site_range_id ? productSiteRange[stateIDs.site_range_id] : null;
                    if (!siteRange) {
                        canNotEdit = true;
                    } else {
                        for (let navigationPointer in stateIDs) {
                            const toApplyValue = stateIDs[navigationPointer];
                            let currentValue = null;
                            switch (navigationPointer) {
                                case "request_range_id":
                                    currentValue = cartLine.range;
                                    break;
                                case "site_range_id":
                                    currentValue = cartLine.site_range;
                                    break;
                                case "colour_id":
                                    if (siteRange.colour_exceptions.includes(toApplyValue)) {
                                        canNotEdit = true;
                                    } else {
                                        currentValue = cartLine.colour;
                                    }
                                    break;
                                case "style_id":
                                    if (siteRange.style_exceptions.includes(toApplyValue)) {
                                        canNotEdit = true;
                                    } else {
                                        currentValue = cartLine.style;
                                    }
                                    break;
                                case "edge_option_id":
                                    currentValue = cartLine.edging;
                                    break;
                                case "handle_colour_id":
                                    currentValue = cartLine.handle_colour;
                                    break;
                                case "assembly_id":
                                    if (!cachedCabinet.assembly_ids.includes(toApplyValue)) {
                                        canNotEdit = true;
                                    } else {
                                        currentValue = cartLine.rigid ? "rigid" : "flat_pack";
                                    }
                                    break;
                                default:
                                    break;
                            }
                            if (canNotEdit) {
                                break;
                            }
                            currentValue = currentValue ? currentValue : null;
                            if (currentValue !== toApplyValue) {
                                affected = true;
                            }
                        }
                    }
                }

            } else {
                if (nonCabinetStateIDs.site_range_id && nonCabinetStateIDs.site_range_id === cartLine.state_ids.site_range_id) {
                    if ((nonCabinetStateIDs.colour_id || cartLine.colour) && nonCabinetStateIDs.colour_id !== cartLine.colour) {
                        affected = true;
                    } else if ((nonCabinetStateIDs.style_id || cartLine.style) && nonCabinetStateIDs.style_id !== cartLine.style) {
                        affected = true;
                    }
                } else {
                    canNotEdit = true;
                }
            }
            affected = affected && !canNotEdit;
            if (affected) {
                affectedCart.push(cartLine);
            } else {
                unaffectedCart.push(cartLine);
                if (canNotEdit) {
                    $scope.edit_cart_response.can_not_replace_tally += cartLine.quantity;
                    $scope.edit_cart_response.apply_cart_line_errors.push({
                        name: cartLine.description,
                        quantity: cartLine.quantity,
                        error: "Not available in your selected properties"
                    })
                } else {
                    matchedUnaffectedCart.push(cartLine)
                }
            }
        }
    }


    function applyToCart() {

        $scope.affected_cart_tally = 0;

        if (!affectedCart.length) {
            return
        }

        const stateIDs = getSubmitStateIDs();
        const nonCabinetStateIDs = getSubmitStateIDs(true);

        const originalLines = [];
        const replacementLines = [];
        for (let i = 0; i < affectedCart.length; i++) {
            const cartLine = affectedCart[i];
            originalLines.push(cartLine);
            const replacementLine = JSON.parse(JSON.stringify(cartLine));

            const isCabinetLine = cartLine.state_ids.base_component_id === "solution";
            if (isCabinetLine) {
                delete replacementLine.state_ids.request_range_id;
                delete replacementLine.state_ids.site_range_id;
                delete replacementLine.state_ids.colour_id;
                delete replacementLine.state_ids.style_id;
                delete replacementLine.state_ids.edge_option_id;
                delete replacementLine.state_ids.handle_colour_id;
                delete replacementLine.state_ids.assembly_id;

                delete replacementLine.range;
                delete replacementLine.completeRange;
                delete replacementLine.site_range;
                delete replacementLine.colour;
                delete replacementLine.style;
                delete replacementLine.edging;
                delete replacementLine.handle_colour;
                delete replacementLine.rigid;

                for (let navigationPointer in stateIDs) {
                    const toApplyValue = stateIDs[navigationPointer];
                    switch (navigationPointer) {
                        case "request_range_id":
                            replacementLine.range = toApplyValue;
                            replacementLine.completeRange = toApplyValue;
                            replacementLine.state_ids.request_range_id = toApplyValue;
                            break;
                        case "site_range_id":
                            replacementLine.site_range = toApplyValue;
                            replacementLine.state_ids.site_range_id = toApplyValue;
                            break;
                        case "colour_id":
                            replacementLine.colour = toApplyValue;
                            replacementLine.state_ids.colour_id = toApplyValue;
                            break;
                        case "style_id":
                            replacementLine.style = toApplyValue;
                            replacementLine.state_ids.style_id = toApplyValue;
                            break;
                        case "edge_option_id":
                            replacementLine.edging = toApplyValue;
                            replacementLine.state_ids.edge_option_id = toApplyValue;
                            break;
                        case "handle_colour_id":
                            replacementLine.handle_colour = toApplyValue;
                            replacementLine.state_ids.handle_colour_id = toApplyValue;
                            break;
                        case "assembly_id":
                            replacementLine.rigid = toApplyValue === "rigid";
                            replacementLine.state_ids.assembly_id = toApplyValue;
                            break;
                        default:
                            break;
                    }
                }
            } else {
                if (nonCabinetStateIDs.colour_id || cartLine.colour) {
                    replacementLine.colour = nonCabinetStateIDs.colour_id;
                } else if (nonCabinetStateIDs.style_id || cartLine.style) {
                    replacementLine.style = nonCabinetStateIDs.style_id;
                }
            }

            replacementLines.push(replacementLine);
        }

        $rootScope.service.order_edit.validateReplaceCart(originalLines, replacementLines, unaffectedCart, matchedUnaffectedCart, $scope.edit_cart_response);
    }

    function resetEditResponse() {

        $scope.edit_cart_response = new $rootScope.service.order_edit.EditCartResponseModel();

    }


    $scope.resetEdit = function () {
        $scope.view_model.edit_cart_id = defaultEditCartID;
        const cartModel = this.currentCartModel();
        $scope.is_editing = false;
        $scope.show_edit_response = false;
        $scope.editing_model_id = null;
        $scope.view_model.edit_available_in = cartModel.default_edit_available_in;
        resetEditResponse();

        for (let cartModelID in $scope.cart_models) {
            const cartModel = $scope.cart_models[cartModelID];
            cartModel.current_property_model_list = cartModel.navigation_property_model_list.slice();
            for (let modelID in cartModel.property_models) {
                const propertyModel = cartModel.property_models[modelID];
                propertyModel.edit_navigation_ids = {};
                propertyModel.edit_navigation_values = {};
                propertyModel.edit_choice_ids = [];
                propertyModel.current_model = propertyModel.navigation_state ? propertyModel.navigation_state.model : null;
                propertyModel.current_choice = propertyModel.navigation_state ? propertyModel.navigation_state.choice : null;
                propertyModel.current_choice_id = propertyModel.current_choice ? propertyModel.current_choice.id : null;
            }
        }
    }


    $scope.closeEdit = function () {
        if ($scope.showSolutionOverviewView) {
            $scope.showSolutionOverviewView(null);
        }
    }

    $scope.getAvailableChoiceIDs = function (propertyModel) {
        if (!$scope.is_editing && !$scope.show_edit_response) {
            if ($scope.view_model.edit_available_in === "all") {
                return propertyModel.navigation_available_all_choice_ids;
            }
            return propertyModel.navigation_available_any_choice_ids;
        }
        return propertyModel.edit_choice_ids;
    }

    $scope.canReset = function () {
        return $scope.is_editing || $scope.view_model.edit_cart_id !== defaultEditCartID || $scope.view_model.edit_available_in !== "all" || $scope.show_edit_response;
    }

    $scope.toggleEditAvailableIn = function () {
        const editCartID = $scope.view_model.edit_cart_id;
        const setTo = $scope.view_model.edit_available_in !== "all" ? "all" : "any";
        $scope.resetEdit();
        $scope.view_model.edit_cart_id = editCartID;
        $scope.view_model.edit_available_in = setTo;
    }

    $scope.currentCartModel = function () {
        return $scope.cart_models[$scope.view_model.edit_cart_id];
    }


    $scope.confirmEditResponse = function (removeUnmatched) {

        const replacementCart = !removeUnmatched ? $scope.edit_cart_response.replacement_cart : $scope.edit_cart_response.matched_replacement_cart;

        $rootScope.service.order_edit.applyReplacementCart(replacementCart, unrelatedCart, $scope.edit_cart_response, function (success) {
            if (success) {
                if ($scope.overrideCacheInputChoiceIDs) {
                    const navigationModel = getCurrentNavigationModel();
                    const cacheStateIDs = {};
                    for (let i = navigationModel.state_list.length - 1; i >= 0; i--) {
                        const state = navigationModel.state_list[i];
                        if (state.state_ids.solution_id) {
                            break;
                        }
                        if (state.choice_id) {
                            cacheStateIDs[state.navigation_pointer] = state.choice_id;
                        }
                    }
                    $scope.overrideCacheInputChoiceIDs(cacheStateIDs)
                }
                const submitStateIDs = getSubmitStateIDs();
                const stateIDs = siteHelper.simpleCloneObject($rootScope.navigation_model.state_ids);
                for (let navigationPointer in submitStateIDs) {
                    const stateID = submitStateIDs[navigationPointer];
                    if (stateID) {
                        stateIDs[navigationPointer] = stateID;
                    } else {
                        delete stateIDs[navigationPointer];
                    }
                }
                const routeOptions = $rootScope.navigation_manager.createNavigationModel(null, stateIDs).route_options;
                $state.go(routeOptions.route, routeOptions.options)
            }
        });
    }

    if ($scope.overview_solution_listeners) {
        $scope.overview_solution_listeners.prepareEditGeneralOptions = prepareEditGeneralOptions;
    }

}]);